import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import FormHelperText from "@mui/material/FormHelperText";
import { useTheme } from "@mui/material";

import FormFileField from "@covertree/ui/forms/FormFileField";
import { SubmitButton } from "@covertree/ui";
import FormCoverageDocument from "@covertree/ui/forms/FormCoverageDocument";

import { useFormContext } from "react-hook-form";

const FOUR_AND_HALF_MB = 4.5 * 1024 * 1024;

interface ExternalCoverageDocumentsContentProps {
  isAddingEvent: boolean;
  isFailed: boolean;
}

function ExternalCoverageDocumentsContent({
  isAddingEvent,
  isFailed,
}: ExternalCoverageDocumentsContentProps) {
  const theme = useTheme();
  const { watch, setValue } = useFormContext();

  const files = watch("files") || [];

  const removeDocument = (document: File) => {
    setValue(
      "files",
      files.filter((file) => document.name !== file.name)
    );
  };
  return (
    <Grid>
      <Grid gap={4} display="flex" flexDirection="column">
        <Typography mt={3} lineHeight={theme.spacing(4)} fontSize={32}>
          Upload Policy Documents
        </Typography>
        {isFailed && (
          <FormHelperText error>
            Something went wrong. <br /> Proof of coverage has been added, but
            the following documents was not uploaded correctly. Please try
            again.
          </FormHelperText>
        )}
        <FormFileField
          name="files"
          maxFileSize={FOUR_AND_HALF_MB}
          maxFileAmount={10}
          accept={{
            "image/png": [".png"],
            "image/jpeg": [".jpg"],
            "application/pdf": [".pdf"],
          }}
        />
        {files.map((file) => (
          <FormCoverageDocument
            key={file.name}
            document={file}
            removeDocument={removeDocument}
          />
        ))}
        <SubmitButton disabled={!isAddingEvent && !files!.length} width={300}>
          Continue
        </SubmitButton>
      </Grid>
    </Grid>
  );
}

export default ExternalCoverageDocumentsContent;
